<template>
  <div>
    <div class="search">
      <div class="main-row">
        <div class="fields">
          <div class="item">
            <sui-form>
              <sui-form-field>
                <label>Keyword</label>
                <input
                  type="search"
                  placeholder="Enter keyword(s) e.g. Accounting"
                />
              </sui-form-field>
            </sui-form>
          </div>
          <div class="item">
            <label>Job Industry</label>
            <treeselect
              v-model="value"
              :multiple="true"
              :options="options"
              :searchable="true"
              :flatten-search-results="true"
              :clear-on-select="false"
              :max-height="500"
              placeholder="Select Job Industry"
            />
          </div>
          <div class="item">
            <label>Job Category</label>
            <treeselect
              v-model="value"
              :multiple="true"
              :options="options"
              :searchable="true"
              :flatten-search-results="true"
              :clear-on-select="false"
              :max-height="500"
              placeholder="Select Job Category"
            />
          </div>
        </div>
        <div class="search-button">
          <button><i class="las la-search"></i></button>
        </div>
        <!-- <span v-if="readMore"></span> -->
      </div>
      <div class="salary-range">
        <button @click="isShowing ^= true">Salary Range</button>
        <div class="display-box" v-show="isShowing">
          <sui-form>
            <!--Range-->
            <sui-form-field>
              <!-- <label>Salary Range (THB)</label> -->
              <div class="range-slider">
                <div class="slider-area">
                  <RangeSliderMinMax />
                </div>
              </div>
            </sui-form-field>
            <!--Number Box-->
            <div class="num-box-row">
              <sui-form-field>
                <label>Min.</label>
                <input type="text" name="" />
                <span class="baht">฿</span>
              </sui-form-field>
              <span class="dash"><i class="las la-minus"></i></span>
              <sui-form-field>
                <label>Max.</label>
                <input type="text" name="" />
                <span class="baht">฿</span>
              </sui-form-field>
            </div>
            <!--Apply Row-->
            <div class="apply-row">
              <a class="cancel">Cancel</a>
              <a class="apply">Apply</a>
            </div>
          </sui-form>
        </div>
      </div>

      <!-- <div class="expand-row" v-show="showMore">
        <div class="fields">
          <div class="item salary">
            <sui-form>
              <sui-form-field>
                <label>Salary Range (THB)</label>
                <div class="range-slider">
                  <div class="slider-area">
                    <RangeSliderMinMax />
                  </div>
                </div>
              </sui-form-field>
              <div class="num-box-row">
                <sui-form-field>
                  <label>Min.</label>
                  <input type="text" name="" />
                  <span class="baht">฿</span>
                </sui-form-field>
                <span class="dash"><i class="las la-minus"></i></span>
                <sui-form-field>
                  <label>Max.</label>
                  <input type="text" name="" />
                  <span class="baht">฿</span>
                </sui-form-field>
              </div>
            </sui-form>
          </div>
        </div>
      </div>
      <div class="show-more-btn">
        <button @click="showMore = !showMore">
          <span class="showmore" v-if="showMore"
            >Show Less<i class="las la-angle-up"></i
          ></span>
          <span class="showless" v-else
            >Show More<i class="las la-angle-down"></i
          ></span>
        </button>
      </div> -->
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import RangeSliderMinMax from "../../components/ui/RangeSliderMinMax.vue";
export default {
  name: "SearchPC",
  components: { Treeselect, RangeSliderMinMax },
  data() {
    return {
      showMore: false,
      value: null,
      isShowing: false,

      // Define Treeselect Options
      options: [
        {
          id: "a",
          label: "Marketing",
          children: [
            {
              id: "aa",
              label: "Digital Marketing",
            },
            {
              id: "ab",
              label: "Traditional Marketing",
            },
            {
              id: "ac",
              label: "Communications Marketing",
            },
          ],
        },
        {
          id: "b",
          label: "Trading",
          children: [
            {
              id: "ba",
              label: "Trading (Computers / Machinery)",
            },
            {
              id: "bb",
              label: "Trading (Software / Medical)",
            },
            {
              id: "bc",
              label: "Trading (Conductors / Engineering)",
            },
            {
              id: "bd",
              label: "Trading (Shipping / Warehouses)",
            },
          ],
        },
      ],
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.search {
  font-family: "Poppins", sans-serif !important;
  .main-row {
    display: flex;
    align-items: flex-end;
    .fields {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      .item {
        width: 32%;
        margin: 0;
        label {
          color: $black;
          display: block;
          font-size: 1em !important;
          font-weight: 700;
          margin: 0 !important;
          margin-bottom: 0.75rem !important;
          text-transform: none;
        }
        /deep/ .ui.form input {
          border: 1px solid $black !important;
          border-radius: 0 !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 16px;
          font-weight: 400 !important;
          padding: 0;
          padding-left: 1rem !important;
          width: 100%;
          height: 42px;
          &::placeholder {
            color: $placeholder;
            font-size: 14px;
          }
        }
        /deep/ .vue-treeselect {
          border: 1px solid $black;
          .vue-treeselect__control {
            border: 0;
            height: 40px;
            .vue-treeselect__control-arrow {
              color: $black;
            }
            // Custom Values Label Style
            .vue-treeselect__value-container {
              .vue-treeselect__multi-value {
                margin-bottom: 0;
                display: flex;
                flex-wrap: nowrap;
                overflow: hidden;
              }
              .vue-treeselect__multi-value-item-container {
                padding-right: 0;
              }
              .vue-treeselect__multi-value-item {
                display: contents;
                .vue-treeselect__multi-value-label {
                  white-space: nowrap;
                  padding: 0;
                  padding-left: 2px;
                  padding-right: 2px;
                  color: $black;
                  font-size: 16px;
                  &:first-child {
                    padding-left: 5px;
                  }
                }
                .vue-treeselect__value-remove {
                  display: none;
                }
              }
            }
          }
        }
        /deep/ .vue-treeselect__placeholder {
          color: $placeholder;
          font-size: 14px;
          line-height: 40px;
        }
        //Customize Expanded Dropdown Menu
        /deep/ .vue-treeselect__menu-container {
          top: 130%;
          .vue-treeselect__menu {
            border: 0;
            background: white;
            padding: 1rem 1rem;
            border-radius: 10px;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
            border: 1px solid #dddddd;
            font-size: 16px;
            color: $black;
            .vue-treeselect__checkbox,
            .vue-treeselect__checkbox--indeterminate {
              width: 20px;
              height: 20px;
              background-position: auto auto;
            }
            .vue-treeselect__check-mark,
            .vue-treeselect__minus-mark {
              background-size: 10px 10px;
              width: 10px;
              height: 10px;
              position: absolute;
              left: 4px;
              top: 4px;
            }
            .vue-treeselect__checkbox--checked {
              background: #3742fa;
              border-color: #3742fa;
            }
            .vue-treeselect__checkbox--unchecked {
              background: white;
              border-color: rgb(204, 204, 204);
            }
            //Parent Checkbox with Minus
            .vue-treeselect__checkbox--indeterminate {
              background: white;
              border-color: rgb(204, 204, 204);
            }
            //Parent Label
            .vue-treeselect__indent-level-0 {
              label.vue-treeselect__label {
                font-weight: 16px !important;
                font-weight: 500 !important;
              }
              .vue-treeselect__option {
                margin-bottom: 0.85rem;
              }
              .vue-treeselect__indent-level-1 {
                label.vue-treeselect__label {
                  font-size: 16px !important;
                  font-weight: 400 !important;
                }
                .vue-treeselect__option {
                  margin-bottom: 5px !important;
                }
                .vue-treeselect__checkbox--checked {
                  label.vue-treeselect__label {
                    font-weight: 600 !important;
                  }
                }
              }
            }
            .vue-treeselect__label {
              font-weight: 600;
            }
            //Child Label
            .vue-treeselect__list {
              .vue-treeselect__label {
                font-weight: normal !important;
              }
            }
            .vue-treeselect__option--selected {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-button {
      width: auto;
      margin-left: 10px;
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 45px;
        height: 45px;
        background: #3742fa;
        border-radius: 100rem;
        &:hover,
        &:focus {
          filter: contrast(150%);
        }
        .la-search {
          font-size: 24px;
          color: white;
        }
      }
    }
  }
  .salary-range {
    position: relative;
    width: 100%;
    button {
      font-family: "Poppins", sans-serif !important;
      display: inline-flex;
      border: 1px solid $black;
      border-radius: 8px;
      padding: 10px 10px;
      color: $black;
      background: white;
      font-size: 12px;
      font-weight: 500;
      margin: 10px 0;
      margin-bottom: 1rem;
      &:hover,
      &:focus {
        opacity: 0.6;
      }
    }
    .display-box {
      position: absolute;
      top: 55px;
      left: 0;
      display: flex;
      width: 350px;
      height: auto;
      background: white;
      z-index: 1001;
      border: 1px solid rgb(232, 232, 232);
      padding: 30px 30px;
      border-radius: 15px;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      .ui.form {
        width: 100%;
        .range-slider {
          margin-bottom: 1rem;
          width: 100%;
          .text {
            color: $black;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 0.5rem;
          }
          .slider-area {
            padding-top: 1.5rem;
          }
        }
        .num-box-row {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .field {
            width: 45%;
            margin: 0;
            position: relative;
          }
          label {
            font-weight: normal;
            font-weight: 500;
            font-size: 12px;
          }
          input[type="text"] {
            text-align: right;
            padding-right: 1rem;
            font-size: 16px;
            color: $black;
            border: 1px solid black;
            border-radius: 0;
          }
          .baht {
            display: inline-block;
            position: absolute;
            top: 35px;
            left: 15px;
            color: $black;
            font-size: 1em;
            font-weight: 500;
          }

          .dash {
            width: 40px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .apply-row {
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding-top: 20px;
          a {
            padding: 0;
            font-size: 14px;
            font-weight: 600;
          }
          .cancel {
            color: #787a7a;
          }
          .apply {
            color: #3742fa;
          }
        }
      }
    }
  }

  // .show-more-btn {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   padding: 2rem 0;
  //   button {
  //     display: inline-flex;
  //     align-items: center;
  //     font-size: 14px;
  //     font-weight: 500;
  //     font-family: "Poppins", sans-serif;
  //     color: #3742fa;
  //     i {
  //       font-size: 14px;
  //       margin-left: 5px;
  //     }
  //   }
  // }
}

@media only screen and (max-width: 991px) {
}
</style>
